export default {
  dark: 'Tume',
  light: 'Valgus',
};
